<template>
<h1><font-awesome-icon icon="signal" /></h1>
<u>Signalst&auml;rke</u>
<br>
<br>
<font-awesome-icon icon="wifi" /> WLAN: <b>{{wifi}} dBm</b>
<br><br>
<div v-if="seveninone"> <font-awesome-icon icon="tower-broadcast" /> 7in1: <b>{{seveninone}} dBm</b></div>
<div v-if="lightning"><br> <font-awesome-icon icon="tower-broadcast" /> Blitzsensor: <b>{{lightning}} dBm</b></div>
<div v-if="feinstaub"><br> <font-awesome-icon icon="wifi" /> Feinstaubsensor: <b>{{feinstaub}} dBm</b></div>
</template>

<script>

export default {
  name: 'SignalStrength',
  props: {
    wifi: Number,
    seveninone: Number,
    lightning: Number,
    feinstaub: Number
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
